@if (layout && layout.HeaderLayout) {
  <ng-template #bookingAuthTemplate>
    @if (usesAuthenticationModule()) {
      <button
        class="booking-auth-button"
        type="button"
        [class.is-authenticated]="bookingAuthService.isLoggedIn()"
        [disabled]="bookingAuthService.isLoadingProfile()"
        [attr.aria-label]="
          bookingAuthService.isLoadingProfile()
            ? 'Loading profile'
            : bookingAuthService.isLoggedIn()
              ? 'Open profile'
              : 'Log in'
        "
        (click)="handleBookingAuthClick()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M20 21a8 8 0 0 0-16 0" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </button>
    }
  </ng-template>

  <ng-template #linksTemplate let-links="links" let-overlay="overlay">
    @for (link of links; track link; let i = $index) {
      @if (!link.Children || link.Children.length === 0) {
        @if (link.ExternalLink) {
          <a
            href="{{ link.Url }}"
            target="_blank"
            rel="noopener"
            (click)="overlay ? hideMenu() : null"
            >{{ link.Name }}</a
          >
        } @else {
          <a
            [routerLink]="[link.Url]"
            (click)="hideMenu()"
            routerLinkActive="active"
            >{{ link.Name }}</a
          >
        }
      } @else {
        <div class="has-submenu">
          <button class="submenu-trigger" type="button">
            {{ link.Name }}<span>&#9662;</span>
          </button>
          <div class="sub-list">
            @for (child of link.Children; track child) {
              @if (child.ExternalLink) {
                <a
                  href="{{ child.Url }}"
                  target="_blank"
                  rel="noopener"
                  (click)="overlay ? hideMenu() : null"
                  >{{ child.Name }}</a
                >
              } @else {
                <a
                  [routerLink]="[child.Url]"
                  (click)="hideMenu()"
                  routerLinkActive="active"
                  >{{ child.Name }}</a
                >
              }
            }
          </div>
        </div>
      }
    }
  </ng-template>

  @switch (layout.HeaderLayout.Type) {
    @case (1) {
      <nav
        [style]="styleString"
        class="type-{{ layout.HeaderLayout.Type }} {{
          layout.HeaderLayout.FullWidth ? 'full-width' : 'boxed'
        }} {{ layout.HeaderLayout.FixedDesktop ? 'fixed-desktop' : '' }} {{
          layout.HeaderLayout.FixedTablet ? 'fixed-tablet' : ''
        }} {{ layout.HeaderLayout.FixedMobile ? 'fixed-mobile' : '' }}"
      >
        @if (layout.HeaderLayout.ShowLogo) {
          <app-header-logo
            [layout]="layout"
            [height]="headerHeight"
          ></app-header-logo>
        }
        <div class="desktop-links">
          <ng-container
            [ngTemplateOutlet]="linksTemplate"
            [ngTemplateOutletContext]="{
              links: layout.HeaderLayout.Links,
              overlay: false,
            }"
          ></ng-container>
          <ng-container [ngTemplateOutlet]="bookingAuthTemplate"></ng-container>
        </div>
        <div
          id="nav-menu"
          [ngClass]="{
            'show-menu': showMenu,
            'menu-right': isMobileMenuRight(),
            'menu-left': !isMobileMenuRight(),
          }"
        >
          <ng-container
            [ngTemplateOutlet]="linksTemplate"
            [ngTemplateOutletContext]="{
              links: layout.HeaderLayout.Links,
              overlay: true,
            }"
          ></ng-container>
        </div>

        <button
          [ngClass]="{ open: showMenu }"
          id="nav-icon"
          type="button"
          aria-label="Vis menyen"
          (click)="showMenuToggle()"
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>
    }

    @case (2) {
      <nav
        [style]="styleString"
        class="type-{{ layout.HeaderLayout.Type }} {{
          layout.HeaderLayout.FullWidth ? 'full-width' : 'boxed'
        }} {{ layout.HeaderLayout.FixedDesktop ? 'fixed-desktop' : '' }} {{
          layout.HeaderLayout.FixedTablet ? 'fixed-tablet' : ''
        }} {{ layout.HeaderLayout.FixedMobile ? 'fixed-mobile' : '' }}"
      >
        <div class="type-2-logo-row">
          @if (layout.HeaderLayout.ShowLogo) {
            <app-header-logo
              [layout]="layout"
              [height]="headerHeight"
            ></app-header-logo>
          }
        </div>

        <div class="desktop-links type-2-links-row">
          <ng-container
            [ngTemplateOutlet]="linksTemplate"
            [ngTemplateOutletContext]="{
              links: layout.HeaderLayout.Links,
              overlay: false,
            }"
          ></ng-container>
        </div>

        <div
          id="nav-menu"
          [ngClass]="{
            'show-menu': showMenu,
            'menu-right': isMobileMenuRight(),
            'menu-left': !isMobileMenuRight(),
          }"
        >
          <ng-container
            [ngTemplateOutlet]="linksTemplate"
            [ngTemplateOutletContext]="{
              links: layout.HeaderLayout.Links,
              overlay: true,
            }"
          ></ng-container>
        </div>

        <ng-container [ngTemplateOutlet]="bookingAuthTemplate"></ng-container>

        <button
          [ngClass]="{ open: showMenu }"
          id="nav-icon"
          type="button"
          aria-label="Vis menyen"
          (click)="showMenuToggle()"
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>
    }

    @case (3) {
      <nav
        class="type-{{ layout.HeaderLayout.Type }} {{
          layout.HeaderLayout.FullWidth ? 'full-width' : 'boxed'
        }} {{ layout.HeaderLayout.FixedDesktop ? 'fixed-desktop' : '' }} {{
          layout.HeaderLayout.FixedTablet ? 'fixed-tablet' : ''
        }} {{ layout.HeaderLayout.FixedMobile ? 'fixed-mobile' : '' }}"
      >
        @if (layout.HeaderLayout.ShowLogo) {
          <app-header-logo
            [layout]="layout"
            [height]="headerHeight"
          ></app-header-logo>
        }

        @if (showMenu) {
          <div
            class="type-3-menu-overlay"
            aria-label="Skjul menyen"
            (click)="hideMenu()"
          ></div>
        }

        <div
          id="nav-menu"
          [ngClass]="{
            'show-menu': showMenu,
            'menu-right': isMobileMenuRight(),
            'menu-left': !isMobileMenuRight(),
          }"
        >
          <ng-container
            [ngTemplateOutlet]="linksTemplate"
            [ngTemplateOutletContext]="{
              links: layout.HeaderLayout.Links,
              overlay: true,
            }"
          ></ng-container>
        </div>

        <ng-container [ngTemplateOutlet]="bookingAuthTemplate"></ng-container>

        <button
          [ngClass]="{ open: showMenu }"
          id="nav-icon"
          type="button"
          aria-label="Vis menyen"
          (click)="showMenuToggle()"
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>
    }

    @case (4) {
      <nav
        [style]="styleString"
        class="type-{{ layout.HeaderLayout.Type }} {{
          layout.HeaderLayout.FullWidth ? 'full-width' : 'boxed'
        }} {{ layout.HeaderLayout.FixedDesktop ? 'fixed-desktop' : '' }} {{
          layout.HeaderLayout.FixedTablet ? 'fixed-tablet' : ''
        }} {{ layout.HeaderLayout.FixedMobile ? 'fixed-mobile' : '' }}"
      >
        <div class="desktop-links type-4-left-links">
          <ng-container
            [ngTemplateOutlet]="linksTemplate"
            [ngTemplateOutletContext]="{
              links: getLeftLinks(),
              overlay: false,
            }"
          ></ng-container>
        </div>

        <div class="type-4-logo-wrap">
          @if (layout.HeaderLayout.ShowLogo) {
            <app-header-logo
              [layout]="layout"
              [height]="headerHeight"
            ></app-header-logo>
          }
        </div>

        <div class="desktop-links type-4-right-links">
          <ng-container
            [ngTemplateOutlet]="linksTemplate"
            [ngTemplateOutletContext]="{
              links: getRightLinks(),
              overlay: false,
            }"
          ></ng-container>
        </div>

        <div
          id="nav-menu"
          [ngClass]="{
            'show-menu': showMenu,
            'menu-right': isMobileMenuRight(),
            'menu-left': !isMobileMenuRight(),
          }"
        >
          <ng-container
            [ngTemplateOutlet]="linksTemplate"
            [ngTemplateOutletContext]="{
              links: layout.HeaderLayout.Links,
              overlay: true,
            }"
          ></ng-container>
        </div>

        <ng-container [ngTemplateOutlet]="bookingAuthTemplate"></ng-container>

        <button
          [ngClass]="{ open: showMenu }"
          id="nav-icon"
          type="button"
          aria-label="Vis menyen"
          (click)="showMenuToggle()"
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>
    }
  }
  @if (showAuthDialog) {
    <app-booking-auth-dialog
      (closed)="closeBookingAuthDialog()"
      (authenticated)="closeBookingAuthDialog()"
    ></app-booking-auth-dialog>
  }
}
